import React from 'react';
import {PropTypes} from 'prop-types';
import {ToString, NormalizeClassNameString} from './utils';

export class ButtonBusyIndicatorComponent extends React.Component {

    shouldComponentUpdate(nextProps) {
        const props = this.props;

        let result = 
            (props.visible != nextProps.visible) ||
            (props.iconClass != nextProps.iconClass);

        return result;
    }

    render() {
        let {visible, className} = this.props;

        if (!Boolean(visible)) {
            return null;
        }

        return (<span className={NormalizeClassNameString(ToString(className) + ' fa-spin')} />);
    }
}
ButtonBusyIndicatorComponent.propTypes = {
    visible: PropTypes.bool,
    className: PropTypes.string
}
ButtonBusyIndicatorComponent.defaultProps = {
    visible: false,
    className: 'fa fa-sun-o ml-1'
}
